/*
 * Copyright (c) Siemens Energy AG 2020 ALL RIGHTS RESERVED
 * I&C Monitors and Advisors (ICMA)
*/
import React from 'react';

export default class AlertComponent extends React.Component {

  removeAlert(id){
    this.props.doRemoveAlert(id);
  };

  render() {
    return (
      <div className={`dls-cs-alert dls-cs-alert-${this.props.type}`}>
        <span className="dls-cs-alert-closebtn" onClick={this.removeAlert.bind(this, this.props.index)}>&times;</span>
        {this.props.message}
      </div>
    )
  }
}
